import { t } from '@/i18n';

/** Comic-ish full-page fallback for crashes (global error boundary and route errors). */
export function ErrorFallback({ error }: { error?: unknown }) {
  const detail = import.meta.env.DEV && error instanceof Error ? error.message : null;
  return (
    <main className="flex min-h-dvh items-center justify-center p-6" data-testid="error-fallback">
      <div className="max-w-md -rotate-1 rounded-lg border-4 border-ink bg-white p-6 text-center shadow-ink-lg">
        <div className="comic mb-2 text-6xl text-team-b ink-text">KABOOM!</div>
        <h1 className="comic mb-3 text-3xl">{t('errorBoundary.title')}</h1>
        <p className="mb-4 font-bold">{t('errorBoundary.text')}</p>
        {detail ? <pre className="mb-4 overflow-auto text-left text-xs">{detail}</pre> : null}
        <div className="flex justify-center gap-3">
          <button
            type="button"
            className="rounded-md border-[3px] border-ink bg-yellow px-4 py-2 font-extrabold shadow-ink-sm"
            onClick={() => window.location.reload()}
          >
            {t('errorBoundary.reload')}
          </button>
          <a
            href="/"
            className="rounded-md border-[3px] border-ink bg-white px-4 py-2 font-extrabold shadow-ink-sm"
          >
            {t('errorBoundary.home')}
          </a>
        </div>
      </div>
    </main>
  );
}
